/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.identity.getRecommendedDidCredentials'

export { $nsid }

/** Describe the credentials that should be included in the DID doc of an account that is migrating to this service. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    rotationKeys: l.optional(l.array(l.string())),
    alsoKnownAs: l.optional(l.array(l.string())),
    verificationMethods: l.optional(l.lexMap()),
    services: l.optional(l.lexMap()),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
